import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GuardHelper } from '../_helpers/guardHelper';

@Injectable({ providedIn: 'root' })
export class CustomerGuard  {
  constructor(
    private guardHelper: GuardHelper
  ) { }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.guardHelper.checkAuthenticatedRole("Customer", state);
  }
}
